module.exports = __webpack_public_path__ + "b362f1a92bcca160e3da43e4fd2ec6bd.pdf";